/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitGuidelinesResults,
    PressKitGuidelinesResultsFromJSON,
    PressKitGuidelinesResultsFromJSONTyped,
    PressKitGuidelinesResultsToJSON,
} from './PressKitGuidelinesResults';

/**
 * プレスキットガイドラインの情報
 * @export
 * @interface PressKitGuidelines
 */
export interface PressKitGuidelines {
    /**
     * 企業のプレスキットのガイドラインの総数
     * @type {number}
     * @memberof PressKitGuidelines
     */
    total: number;
    /**
     * 
     * @type {PressKitGuidelinesResults}
     * @memberof PressKitGuidelines
     */
    results: PressKitGuidelinesResults;
}

export function PressKitGuidelinesFromJSON(json: any): PressKitGuidelines {
    return PressKitGuidelinesFromJSONTyped(json, false);
}

export function PressKitGuidelinesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitGuidelines {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'results': PressKitGuidelinesResultsFromJSON(json['results']),
    };
}

export function PressKitGuidelinesToJSON(value?: PressKitGuidelines | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': PressKitGuidelinesResultsToJSON(value.results),
    };
}

